import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import DateRange from "../../components/DateRange/DateRange";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import Select from "react-select";
import {
  customFilterOption,
  formatOptionLabel,
} from "../../components/StaticData";
import { URLS } from "../../Services/Constant";
import { get, post, patch } from "../../Services/ApiHandler";
import { eye_view, red_flag, Search_icon, view_icon } from "../../assets/img";
import moment from "moment";
import { checkPermission } from "../redux/api/PermissionManager";
import { Table } from "../../components/Table/Table";
import { toast } from "react-toastify";
import ReadNotificationPopup from "../../components/ReadNotificationPopup";
import UnReadNotificationPopup from "../../components/UnReadNotificationPopup";

const PropertyRedFlag = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [submissionDescription, setSubmissionDescription] = useState("");
  const fromDate = moment().startOf("month").format("YYYY-MM-DD");
  const toDate = moment().endOf("month").format("YYYY-MM-DD");
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? fromDate,
    to: paginationData?.[path]?.to ?? toDate,
    city: "",
    owner: "",
    search: paginationData?.[path]?.search ?? "",
    unread_only: false,
  });
  const [isViewDetails, setIsViewDetails] = useState({
    ispopUp: false,
    details: {},
  });
  const [PropertiesList, setPropertiesList] = useState([]);
  const [optionsList, setOptionsList] = useState({
    owners: [],
    cities: [],
  });

  const [countData, setCountData] = useState([]);

  const [popup, setPopup] = useState(false);

  const getList = async (pageNumber = 1) => {
    const { city, from, owner, search, to } = selectedFilter;
    const payload = new FormData();
    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (city) {
      payload.append("city", city?.value);
    }
    if (owner) {
      payload.append("owner", owner?.value);
    }
    const res = await post(
      `${URLS.PROPERTY_RED_FLAG_LIST}?page=${pageNumber}&unread_only=${selectedFilter?.unread_only}`,

      // URLS.PROPERTY_RED_FLAG_LIST + "?page=" + pageNumber,
      payload,
    );

    console.log("overall properties", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setPropertiesList(res?.data);
    }
  };

  useEffect(() => {
    getOwnerList();
    getCities();
  }, []);

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: selectedFilter.search },
    }));
  }, [
    selectedFilter.city,
    selectedFilter.owner,
    selectedFilter.search,
    page,
    selectedFilter?.unread_only,
  ]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  console.log("page", page);

  const getOwnerList = async (search) => {
    console.log("search", search);
    const res = await get(
      `${URLS.OWNERS_DROPDOWN}${search ? "?search=" + search : ""}`,
    );
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name, ...item };
      });
      console.log("owner response success", res, modifiedList);
      setOptionsList((prev) => ({ ...prev, owners: modifiedList }));
    }
  };

  const handleStatus = async ({ property_id, status }) => {
    if (!checkPermission("CAN-STATUS-OVERALL_PROPERTIES")) return;
    const payload = new FormData();
    payload.append("status", status === 2 ? 3 : 2);
    const res = await patch(
      URLS.PROPERTY_STATUS + property_id + "/status/",
      payload,
    );
    console.log("property status", res);
    if (res?.status === "success") {
      toast.success(
        res?.message || status == 2
          ? "Property deactivated successfully"
          : "Property activated successfully",
      );
      getList(page);
    }
  };

  //cities with properties list
  const getCities = async () => {
    const res = await get(URLS.PROPERTY_CITIES);
    console.log("properties cities", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const handleCount = async ({
    property_id,
    owner_code,
    category_id,
    property_name,
    owner_name,
    owner_id,
  }) => {
    const { from, to } = selectedFilter;
    let payload = new FormData();
    payload.append("property_id", property_id);
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }

    let res = await post(URLS.PROPERTY_FLAG_COUNT_DETAIL, payload);
    console.log("resCount", res);
    if (res?.status == "success") {
      let data = res?.data
        ?.map((i) => {
          return i?.details?.map((item) => {
            return {
              ...item,
              cancelled_date: i?.cancelled_date,
              property_id: property_id,
              owner_code: owner_code,
              category_id: category_id,
              property_name: property_name,
              owner_name: owner_name,
              owner_id: owner_id,
            };
          });
        })
        .flat();
      console.log("mappedData", data);
      setCountData(data ?? []);
      setPopup(true);
    }
  };

  const navigate = useNavigate();

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          const isSelected = selectedOwners.includes(
            row.original.unread_notification_id,
          );

          const handleCheckboxChange = (e) => {
            if (e.target.checked) {
              setSelectedOwners((prev) => [
                ...prev,
                row.original.unread_notification_id,
              ]);
            } else {
              setSelectedOwners((prev) =>
                prev.filter((id) => id !== row.original.unread_notification_id),
              );
            }
          };

          return (
            <div
              style={{
                flexDirection: "row-reverse",
                alignItems: "center",
                display: "flex",
                gap: 5,
              }}
            >
              <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>
              {row?.original?.has_unread_notification && (
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={handleCheckboxChange}
                  style={{ width: 20, height: 20, marginTop: 9 }}
                />
              )}
              {!row?.original?.has_unread_notification && (
                <img
                  src={eye_view}
                  style={{ width: 20, height: 20, marginTop: 5 }}
                  onChange={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                  onClick={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                />
              )}
            </div>
          );
          // const pageSize = 10;
          // return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
        // Cell: ({ row }) => {
        //   const pageSize = 10;
        //   return <p className="">{row.index + 1 + (page - 1) * pageSize}</p>;
        // },
      },
      {
        Header: "Flag",
        accessor: "flag",
        Cell: ({ value, row }) => {
          return <img src={red_flag} height={"20px"} width={"20px"} />;
        },
      },
      {
        Header: " Property",
        accessor: "property_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap">
              <p className="primary pointer">{value}</p>
            </div>
          );
        },
      },
      {
        Header: "Registration Date",
        accessor: "registration_date",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD/MM/YYYY")}</p>;
        },
      },
      {
        Header: "Owner",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap ">
              <p className="primary pointer">{value}</p>
            </div>
          );
        },
      },
      {
        Header: " Email",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Mobile Number",
        accessor: "mobile_number",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Location",
        accessor: "location",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Requested By",
        accessor: "requested_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Cancel Count",
        accessor: "cancel_count",
        Cell: ({ value, row }) => {
          return (
            <div
              onClick={() => handleCount(row?.original)}
              className="d-flex ac-js gap-3"
            >
              <p className="text-nowrap">{value}</p>
              <img src={view_icon} alt="" className=" edit-btn " />
            </div>
          );
        },
      },
      checkPermission("CAN-STATUS-PROPERTY__RED_FLAG") && {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return value === 2 ? (
            <button
              onClick={() => handleStatus(row.original)}
              className="active-btn border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
            >
              Active
            </button>
          ) : (
            <button
              onClick={() => handleStatus(row.original)}
              className="deactive-btn border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
            >
              De-active
            </button>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "id",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                className="cust-btn "
                onClick={() => {
                  navigate("/property-details", {
                    state: {
                      id: row?.original.property_id,
                      owner: row.original?.owner_id,
                      owner_name: row.original?.owner_name,
                      property_name: row.original?.property_name,
                      category_id: row.original?.category_id,
                      owner_code: row.original?.owner_code,
                      sub_tabs: 5,
                    },
                  });
                }}
              >
                <img src={view_icon} alt="" className=" edit-btn " />
              </button>
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-PROPERTY__RED_FLAG") ? [...d, action] : d;
  }, [page, selectedOwners]);

  useEffect(() => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        ...prev?.[path],
        from: prev?.[path]?.from ?? fromDate,
        to: prev?.[path]?.to ?? toDate,
      },
    }));
  }, []);
  const handleSumbit = async () => {
    let payload = {
      ids: selectedOwners,
      description: submissionDescription,
    };

    try {
      let url = URLS.NOTIFICATION_COUNTREDUCE;
      let res = await post(url, payload);
      if (res?.status === "success") {
        // console.log("Description:", submissionDescription);
        toast.success("Read Notification has be Success");
        setShowSubmitPopup(false);
        setSubmissionDescription("");
        setSelectedOwners([]);
        getList();
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
  };
  return (
    <div>
      <Topbar header={"Red Flag"} subHead={"Flag"} />
      <div style={{ flexDirection: "row", display: "flex", gap: 50 }}>
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{count}
        </h2>
        <div className="d-flex" style={{ alignItems: "center" }}>
          <input
            type="checkbox"
            checked={selectedFilter?.unread_only}
            onChange={() =>
              handleChangeFilter("unread_only", !selectedFilter?.unread_only)
            }
          />{" "}
          <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 ">
            Check New Notification
          </p>
          {/* <Select
            className="location-search"
            options={[{ label: "New to Old", value: "newtoold" }]}
            isClearable
            // onChange={(e) => {
            //   handleChangeFilter("property", e);
            // }}
            // value={selectedFilter?.property}
            placeholder={"property"}
          /> */}
        </div>
      </div>
      {/* <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{count}
      </h2> */}
      <div className="d-flex ac-je mt-3 gap-1 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
          fromDate={selectedFilter.from}
          toDate={selectedFilter.to}
        />
        <Select
          className="location-search"
          options={optionsList?.cities}
          placeholder={"City"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("city", e);
          }}
          value={selectedFilter?.city}
        />
        <Select
          className="location-search"
          options={optionsList?.owners}
          isClearable
          onChange={(e) => {
            handleChangeFilter("owner", e);
          }}
          formatOptionLabel={formatOptionLabel}
          filterOption={customFilterOption}
          value={selectedFilter?.owner}
          placeholder={"Owner"}
        />
        <div className="search-input">
          <input
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
          />
          <img src={Search_icon} className="search" alt="search" />
        </div>
      </div>
      {selectedOwners.length > 0 && (
        <div
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-2 "
          style={{ width: 90 }}
          onClick={() => setShowSubmitPopup(true)}
        >
          <p>Submit</p>
        </div>
      )}
      <Table
        pageno={page}
        columns={columns}
        setPageno={setPage}
        // pagecount={pagination}
        data={PropertiesList}
        show={true}
        getRowProps={(row) => ({
          style: {
            backgroundColor: row.original.has_unread_notification
              ? "#eeeeee91"
              : "#fff",
          },
        })}
      />

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="col-md-12 d-flex flex-wrap justify-content-center">
              {countData?.map((i, ind) => {
                const isLessItems = countData.length <= 2;

                return (
                  <div
                    key={ind}
                    className="px-3 my-4"
                    style={{
                      width: isLessItems ? "70%" : "50%",
                    }}
                  >
                    <div className="border p-3 rounded">
                      <h2 className="text-start f3 fs-sm-16 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">
                        {moment(i?.cancelled_date).format("MMM Do YYYY")}
                      </h2>

                      <div className="d-flex justify-content-between mt-2">
                        <div
                          onClick={() =>
                            navigate("/property-details", {
                              state: {
                                id: i.property_id,
                                owner: i?.owner_id,
                                owner_name: i?.owner_name,
                                property_name: i?.property_name,
                                category_id: i?.category_id,
                                owner_code: i?.owner_code,
                                sub_tabs: 6,
                                from_date: selectedFilter?.from,
                                to_date: selectedFilter?.to,
                              },
                            })
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <p className="gray mb-2">Check-in Date</p>
                          <p className="text-decoration-underline">
                            {moment(i?.check_in_date).format("DD-MM-YYYY")}
                          </p>
                        </div>

                        <div>
                          <p className="gray mb-2">No of rooms</p>
                          <p>{i?.no_of_rooms}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <button
              onClick={() => setPopup(false)}
              className="back-btn f2 w-40 mt-3"
            >
              Close
            </button>
          </div>
        </div>
      )}
      {showSubmitPopup && (
        <ReadNotificationPopup
          setSubmissionDescription={setSubmissionDescription}
          setShowSubmitPopup={setShowSubmitPopup}
          submissionDescription={submissionDescription}
          handleSumbit={handleSumbit}
        />
      )}
      {isViewDetails?.ispopUp ? (
        <UnReadNotificationPopup
          setIsViewDetails={setIsViewDetails}
          // setShowSubmitPopup={setShowSubmitPopup}

          isViewDetails={isViewDetails}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default PropertyRedFlag;
